module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.13828/img/business-types/professional-service.png"